module.exports = __webpack_public_path__ + "img/bay-hotel-2.04a907a3.jpg";